import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserCheckupsAggregate = () => {
    const { reportData } = useContext(ReportContext);
    const data = reportData;

    const columns = [
        {
            field: 'checkupType',
            name: 'Checkup Type',
            dataType: 'multiselect',
            styles: { minWidth: '20rem' },
        },
        {
            field: 'totalStarts',
            name: 'Total Starts',
            dataType: 'numeric',
        },
        {
            field: 'totalCompletes',
            name: 'Total Completes',
            dataType: 'numeric',
        },
    ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable data={data} columns={columns} />

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides an aggregate view of user checkup activity within
                    the platform for the selected time period and filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Checkup Type">
                    The type of the checkup assessment.{' '}
                    <span className="italic">Initial</span> refers to the onboarding
                    checkup the user is presented with on their initial registration and{' '}
                    <span className="italic">Subsequent</span> refers to any checkup they
                    took after.{' '}
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Total Starts">
                    The total number of times users initiated this checkup type.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Total Completes">
                    The total number of times users fully completed this checkup type.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserCheckupsAggregate;
